module.exports = __webpack_public_path__ + "img/presentation07.d43ee936.jpg";